import { productGridCardStyles } from "@dana/Overrides/Widgets/ProductList/ProductListProductGridCard";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

productGridCardStyles.wrapper = mergeToNew(productGridCardStyles.wrapper, {
    css: css`
        padding-bottom: 0;
        overflow: visible;
    `,
});

productGridCardStyles.imageWrapper = mergeToNew(productGridCardStyles.imageWrapper, {
    css: css`
        margin: 0;
        padding: 0;
    `,
});